var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91537 9.9165V11.0832C9.91537 11.4053 10.1765 11.6665 10.4987 11.6665C10.8209 11.6665 11.082 11.4053 11.082 11.0832V2.33317H2.91536V8.74984H1.7487V1.74984C1.7487 1.42767 2.00987 1.1665 2.33203 1.1665H11.6654C11.9875 1.1665 12.2487 1.42767 12.2487 1.74984V11.0832C12.2487 12.0497 11.4652 12.8332 10.4987 12.8332H2.33203C1.36554 12.8332 0.582031 12.0497 0.582031 11.0832V9.9165H9.91537Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.3a5bc937821e9bc77307f04bfe78f482.svg";
export { ForwardRef as ReactComponent };